<template>
  <div class="store">
    <div class="head">
      <h3 class="back" @click="$emit('back')">
        <i class="fa fa-chevron-left" />
        <span>{{ $t('store.back') }}</span>
      </h3>
      <i class="fp4 fp4-xmark close" @click="$emit('close')" />
    </div>
    <div class="details">
      <div class="left">
        <fpui-canvas-icon
          :name="pckgName"
          backgroundColor="white"
          :logo="value.image"
          fontSize="68px"
          :width="158"
          :height="158"
        />
        <div class="version">
          <div class="title">{{ $t('store.version') }}</div>
          <div class="content">{{ lastVersion }}</div>
        </div>
        <div class="author">
          <div class="title">{{ $t('store.author') }}</div>
          <div class="content">
            <img :src="fpIcon">
            <span>{{ owner }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="big-title">{{ pckgName }}</div>
        <div class="categories" v-if="pckgCategories.length">
          <div
            v-for="(category, idx) in pckgCategories"
            :key="`ctg-${idx}`"
            class="category"
          >{{ category }}</div>
        </div>
        <div class="description">
          <div class="title">{{ $t('store.description') }}</div>
          <div class="content">
            <span v-html="$sanitize(pckgLongDescription || pckgDescription)" />
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <img :src="icForepaasStore">
      <fpui-button
        v-if="onSelect"
        class="pull-right"
        :disabled="value.disable"
        v-tooltip="value.disable ? (value.disableReason || '') : ''"
        color="green"
        @click="confirm"
      >{{ $t('store.select') }}</fpui-button>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'
import gt from 'semver/functions/gt'
import coerce from 'semver/functions/coerce'

export default {
  props: {
    value: { type: Object, default: () => { } },
    onSelect: { type: Function, default: null }
  },
  computed: {
    pckgType () {
      return this.value?.type.split('.')[0]
    },
    locale () {
      return this.$i18n.locale()
    },
    icForepaasStore () { return require('./ovh_cloud_store@2x.png') },
    fpIcon () { return require('@/shared/assets/img/ovhcloud_logo_simplified_blue.svg') },
    pckgLongDescription () {
      const longDescriptionKey = `${this.pckgType}.${this.value?.id}.long_description`
      return _get(
        this.value,
        `i18n.${this.$i18n.locale()}.long_description`,
        (this.$i18n.keyExists(longDescriptionKey) ? this.$t(longDescriptionKey) : (this.value?.type === '' ? (this.value?.long_description || this.pckgDescription) : this.pckgDescription))
      )
    },
    pckgDescription () {
      const descriptionKey = `${this.pckgType}.${this.value?.id}.description`
      return _get(
        this.value,
        `i18n.${this.$i18n.locale()}.description`,
        (this.$i18n.keyExists(descriptionKey) ? this.$t(descriptionKey) : (this.value?.type === '' ? (this.value?.description || this.$t('store.no_description')) : this.$t('store.no_description')))
      )
    },
    pckgName () {
      const nameKey = `${this.pckgType}.${this.value?.id}.name`
      return _get(
        this.value,
        `i18n.${this.$i18n.locale()}.name`,
        (this.$i18n.keyExists(nameKey) ? this.$t(nameKey) : this.value?.name)
      )
    },
    pckgCategories () {
      const categoryKey = `${this.pckgType}.${this.value?.id}.category`
      const category = this.$i18n.keyExists(categoryKey) ? this.$t(categoryKey) : this.value?.category
      if (!this.value.category) return []
      // Same global keys as the store tiles (StoreMain.pckgCategory)
      return (Array.isArray(category) ? category : [category]).map(c => {
        const globalCategoryKey = `store.package.category.${c}`
        return this.$i18n.keyExists(globalCategoryKey) ? this.$t(globalCategoryKey) : c
      })
    },
    lastVersion () {
      const versions = _get(this.value, 'versions', [])
      return [...versions].sort((a, b) => {
        // coerce turns the tag into a semver for gt; it returns null for
        // non-semver tags (dates, timestamps, 'latest'), which sort last
        const v1 = coerce(a.split('/').pop())
        const v2 = coerce(b.split('/').pop())
        if (!v1 || !v2) return Number(!v1) - Number(!v2)
        if (gt(v1, v2)) return -1
        if (gt(v2, v1)) return 1
        return 0
      })[0]
    },
    owner () {
      const organization = this.$store.getters.ORGANIZATION_BY_ID(this.value.owner)
      if (organization && this.value.owner !== 'forepaas') {
        return organization.name
      }
      return 'Data Platform'
    }
  },
  methods: {
    confirm () {
      return this.onSelect(this.value, this)
    }
  }
}
</script>
